import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function NewsletterForm({ variant = "full", testIdPrefix = "newsletter-form" }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", consent: false });
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) {
      setError(t("newsletter.error_required"));
      return;
    }
    if (!EMAIL_RE.test(form.email.trim())) {
      setError(t("newsletter.error_email"));
      return;
    }
    setError("");
    try {
      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        ts: new Date().toISOString(),
      };
      const prev = JSON.parse(localStorage.getItem("xeloriq_leads") || "[]");
      prev.push(payload);
      localStorage.setItem("xeloriq_leads", JSON.stringify(prev));
    } catch {}
    navigate("/thank_you");
  };

  const isCompact = variant === "compact";

  return (
    <form
      onSubmit={handleSubmit}
      data-testid={`${testIdPrefix}-container`}
      className={`bg-white border border-[#CBD5E1] p-6 md:p-7 ${isCompact ? "" : "shadow-sm"}`}
      noValidate
    >
      <div className="space-y-4">
        <div>
          <label
            htmlFor={`${testIdPrefix}-name`}
            className="block text-xs font-semibold uppercase tracking-wider text-[#4A5568] mb-1.5"
          >
            {t("newsletter.name_label")}
          </label>
          <input
            id={`${testIdPrefix}-name`}
            type="text"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid={`${testIdPrefix}-name-input`}
            placeholder={t("newsletter.name_placeholder")}
            className="w-full border border-[#CBD5E1] px-3 py-2.5 text-sm text-[#0F172A] focus:outline-none focus:border-[#0B2545]"
            required
          />
        </div>
        <div>
          <label
            htmlFor={`${testIdPrefix}-email`}
            className="block text-xs font-semibold uppercase tracking-wider text-[#4A5568] mb-1.5"
          >
            {t("newsletter.email_label")}
          </label>
          <input
            id={`${testIdPrefix}-email`}
            type="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid={`${testIdPrefix}-email-input`}
            placeholder={t("newsletter.email_placeholder")}
            className="w-full border border-[#CBD5E1] px-3 py-2.5 text-sm text-[#0F172A] focus:outline-none focus:border-[#0B2545]"
            required
          />
        </div>

        <label className="flex items-start gap-2 text-xs text-[#334155] cursor-pointer">
          <input
            type="checkbox"
            checked={form.consent}
            onChange={(e) => setForm({ ...form, consent: e.target.checked })}
            data-testid={`${testIdPrefix}-consent`}
            className="mt-1 accent-[#C85A32]"
          />
          <span>{t("newsletter.consent_label")}</span>
        </label>

        {error && (
          <div
            data-testid={`${testIdPrefix}-error`}
            className="text-xs text-white bg-[#C85A32] px-3 py-2"
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          data-testid={`${testIdPrefix}-submit-button`}
          className="w-full bg-[#0B2545] hover:bg-[#071B34] text-white text-sm font-semibold uppercase tracking-wider py-3"
        >
          {t("newsletter.submit_button")}
        </button>

        <p className="text-[11px] text-[#64748B] leading-normal">
          {t("newsletter.footer_note")}
        </p>
      </div>
    </form>
  );
}
